import React from 'react';
import { Modal, Stack, Text, Loader } from '@mantine/core';

interface ProcessingModalProps {
  opened: boolean;
}

export const ProcessingModal: React.FC<ProcessingModalProps> = ({ opened }) => {
  return (
    <Modal
      opened={opened}
      onClose={() => {
        // Absichtlich leer: Modal kann nicht geschlossen werden während der Verarbeitung
      }}
      title=""
      centered
      size="md"
      withCloseButton={false}
      closeOnClickOutside={false}
      closeOnEscape={false}
    >
      <Stack gap="xl" align="center">
        <Loader size="xl" color="grape" />

        <Text size="lg" ta="center" fw={600}>
          Verarbeitung läuft...
        </Text>

        <Text size="md" ta="center" c="dimmed">
          Wir überprüfen Ihre Daten und bereiten alles für Sie vor.
        </Text>

        <Text size="sm" ta="center" c="dimmed" fs="italic">
          Dies dauert nur einen Moment.
        </Text>
      </Stack>
    </Modal>
  );
};
